import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=4c67c182"
import script from "./Waiting.vue?vue&type=script&lang=js"
export * from "./Waiting.vue?vue&type=script&lang=js"
import style0 from "./Waiting.vue?vue&type=style&index=0&id=4c67c182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports